import IconComponent from "icons/IconComponent";

import PlusIcon from "./plus.svg";

export default (PlusIcon as any) as IconComponent;
